import * as yup from "yup";

import { TARIFAS } from "../ordersVial/formOrderVial/serviceDetails";

export const orderValidationSchema = yup.object().shape({
  //Datos del vehiculo
  vehiculos: yup.array().of(
    yup.object().shape({
      vehicle_type_id: yup
        .object()
        .required("Selecciona o registra un tipo de vehículo"),
      brand_id: yup
        .object()
        .required("Selecciona o registra una marca de vehículo"),
      vehicle_model_id: yup
        .object()
        .required("Selecciona o registra un modelo de vehículo"),
      // anio: yup
      //   .object()
      //   .required("El año es obligatorio si la Carta Porte es requerida"),

      color_id: yup.object().required("El color es obligatorio"),
      placas: yup.string().required("El número de placa es obligatorio"),
      //numero_serie: yup.string().required("El número de serie es obligatorio"),

      // vehiculoNumero: yup
      //   .number()
      //   .typeError("Debe ser un número")
      //   .required("El número de vehículos es obligatorio")
      //   .integer("Debe ser un número entero")
      //   .positive("Debe ser un número positivo"),

      carga_kg: yup.number(),
      registrar_volumen: yup.boolean(),
      volumen_largo: yup.number().when("registrar_volumen", {
        is: true,
        then: (schema) =>
          schema
            .typeError("El largo debe ser un número")
            .required("Campo requerido")
            .positive("Debe ser un número positivo"),
        otherwise: (schema) => schema,
      }),
      volumen_ancho: yup.number().when("registrar_volumen", {
        is: true,
        then: (schema) =>
          schema
            .typeError("El ancho debe ser un número")
            .required("Campo requerido")
            .positive("Debe ser un número positivo"),
        otherwise: (schema) => schema,
      }),
      volumen_altura: yup.number().when("registrar_volumen", {
        is: true,
        then: (schema) =>
          schema
            .typeError("La altura debe ser un número")
            .required("Campo requerido")
            .positive("Debe ser un número positivo"),
        otherwise: (schema) => schema,
      }),
      volumen_m3: yup.number().when("registrar_volumen", {
        is: true,
        then: (schema) =>
          schema
            .typeError("El volumen debe ser un número")
            .required("Favor de ingresar las medidas")
            .positive("Debe ser un número positivo"),
        otherwise: (schema) => schema,
      }),
    })
  ),

  // Datos de infracción
  folio: yup
    //.typeError("Debe ser un número")
    //.integer("Debe ser un número entero")
    //.positive("Debe ser un número positivo")
    .string()
    .required("El folio es obligatorio"),

  //expedienteNo: yup
    //.typeError("Debe ser un número")
    //.integer("Debe ser un número entero")
    //.positive("Debe ser un número positivo")
    //.string()
    //.required("El número de expediente es obligatorio"),
  //infraccionNo: yup
    //.typeError("Debe ser un número")
    //.integer("Debe ser un número entero")
    //.positive("Debe ser un número positivo"),
    //.string()
    //.required("El número de infracción es obligatorio"),
  motivoInfraccion: yup
    .string()
    .required("El motivo de la infracción es obligatorio"),
  fecha_hora_orden: yup
    .date()
    .typeError("Debe ser una fecha válida")
    .required("La fecha y hora de la orden es obligatoria"),

  tipoServicio: yup.string().required("El tipo de servicio es obligatorio"),

  // primerServDe: yup.string().required("Campo obligatorio"),
  // primerServA: yup.string().required("Campo obligatorio"),
  // segundoServDe: yup.string().required("Campo obligatorio"),
  // segundoServA: yup.string().required("Campo obligatorio"),
  //oficialOrdenaServicio: yup.string().required("Campo obligatorio"),
  // peritoComandanteDeConocimiento: yup.string().required("Campo obligatorio"),
  // nombreInfractor: yup.string().required("Campo obligatorio"),

  //notas: yup.string().required("Campo obligatorio"),
  otros: yup.boolean(),
  otros_observaciones: yup.string().when("otros", {
    is: true,
    then: (schema) =>
      schema.required("Las descripción de la maniobra es requerida"),
    otherwise: (schema) => schema,
  }),

  montosExtras: yup.array().of(
    yup.object().shape({
      monto_extra_descripcion: yup.string().required("Escriba la descripción"),
      monto_extra_monto: yup
        .number()
        .required("Escriba el monto del servicio adicional")
        .positive("El monto debe ser positivo"),
    })
  ),

  // crane_id: yup
  //   .object()
  //   .shape({
  //     value: yup.mixed().required(),
  //     label: yup.string().required(),
  //   })
  //   .nullable()
  //   .required("Selecciona una grúa"),

  // operator_id: yup.object().required("El operador es obligatorio"),

  // subtotal: yup.number().required("Subtotal obligatorio"),

  estatus: yup.string().oneOf(["Pendiente", "Pagado", "Olvidado", "Cancelado"]),

  payments_contado: yup.array().of(
          yup.object().shape({
              payment_date: yup.date().required("Seleccione la fecha de pago"),
              payment_method_code: yup.string().required("Seleccione el método de pago"),
              metodoPagoSAT: yup.string().required("Seleccione el método de pago SAT"),
              payment_amount: yup.number().required("Escriba el monto").positive('El monto debe ser positivo'),
              bank_account_id: yup.object().when(['payment_method_code'], ([payment_method_code], schema) => {
                  return (payment_method_code === 'TRANSFER' ? schema.required('La cuenta bancaria es obligatoria al seleccionar la transferencia') : schema.nullable());
              }),
          }),
      ),
      
  payments_credito: yup.array().of(
          yup.object().shape({
              payment_date: yup.date().required("Seleccione la fecha de pago"),
              payment_method_code: yup.string().required("Seleccione el método de pago"),
              metodoPagoSAT: yup.string().required("Seleccione el método de pago SAT"),
              payment_amount: yup.number().required("Escriba el monto").positive('El monto debe ser positivo'),
              bank_account_id: yup.object().when(['payment_method_code'], ([payment_method_code], schema) => {
                  return (payment_method_code === 'TRANSFER' ? schema.required('La cuenta bancaria es obligatoria al seleccionar la transferencia') : schema.nullable());
              }),
          }),
      ),

  invoices_contado: yup.array().of(
        yup.object().shape({
            invoice_number: yup.string().required("Escribe el número de factura"),
            invoice_date: yup.date().required("Seleccione la fecha de la factura"),
            invoice_amount: yup.number().required("Escriba el monto").positive('El monto debe ser positivo'),
            bank_account_id: yup.object().when(['payment_method_code'], ([payment_method_code], schema) => {
                return (payment_method_code === 'TRANSFER' ? schema.required('La cuenta bancaria es obligatoria al seleccionar la transferencia') : schema.nullable());
            }),
        }),
    ),

   invoices_credito: yup.array().of(
        yup.object().shape({
            invoice_number: yup.string().required("Escribe el número de factura"),
            invoice_date: yup.date().required("Seleccione la fecha de la factura"),
            invoice_amount: yup.number().required("Escriba el monto").positive('El monto debe ser positivo'),
            bank_account_id: yup.object().when(['payment_method_code'], ([payment_method_code], schema) => {
                return (payment_method_code === 'TRANSFER' ? schema.required('La cuenta bancaria es obligatoria al seleccionar la transferencia') : schema.nullable());
            }),
        }),
    ),
    genera_costo_por_estadia: yup.boolean(),

    tarifa_seleccionada: yup.mixed().when("genera_costo_por_estadia", {
      is: true,
      then: (schema) => schema.required("Selecciona una tarifa"),
      otherwise: (schema) => schema.nullable(),
    }),
}).test(
  "total-mayor-cero",
  "El total debe ser mayor a 0.",
  function (values) {
    const subtotal = parseFloat(values.subtotal || 0);
    const costosAdicionales = (values.montosExtras || []).reduce((acc, item) => {
      const monto = parseFloat(item.monto_extra_monto || 0);
      return acc + (isNaN(monto) ? 0 : monto);
    }, 0);
    const total = subtotal + costosAdicionales;
    
    if (total <= 0) {
      return this.createError({
        message: "El total debe ser mayor a 0",
        path: "total", // Asignar el error a un path específico
      });
    }
    return true;
  }
);

export const quickOrderInitialValues = {
  vehiculos: [],
};

export const orderInitialValues = {
  vehiculos: [
    {
      vehiculoNumero: "",
      vehicle_type_id: "",
      brand_id: "",
      vehicle_model_id: "",
      anio: "",
      color_id: "",
      observaciones: "",
      placas: "",
      numero_serie: "",
      shielding_type_id: "",
      carga_kg: "",
      registrar_volumen: false,
      volumen_largo: "",
      volumen_ancho: "",
      volumen_altura: "",
      volumen_m3: "",
      estado_llantas_giran: "",
      estado_volante_gira: "",
      estado_pie_calle: "",
      estado_neutral: "",
      estado_en_cajon: "",
      asistencia_paso_corriente: "",
      asistencia_combustible: "",
      asistencia_cambio_neumatico: "",
      asistencia_cerrajeria: "",
    },
  ],

  folio: "",
  expedienteNo: "",
  infraccionNo: "",
  motivoInfraccion: "",
  fecha_hora_orden: "",
  tipoServicio: "",

  primerServDe: "",
  primerServA: "",
  segundoServDe: "",
  segundoServA: "",
  oficialOrdenaServicio: "",
  peritoComandanteDeConocimiento: "",
  nombreInfractor: "",

  notas: "",
  extinguidor: false,
  llanta_refaccion: false,
  gato: false,
  herramientas: false,
  cable_pasa_corriente: false,
  senalamientos: false,

  horaDeEspera: false,
  acondicionamiento: false,
  estadia: false,
  cargaVaroExpress: false,
  abanderamiento: false,
  custodia: false,
      
  otros: false,
  otros_observaciones: "",

  montosExtras: [],
  crane_id: null,

  operator_id: "",
  chofer_auxiliar_id: "",
  subtotal: "",
  estatus: "Pendiente",


  invoice_folio:'',
  invoice_generation_date:'',

  genera_costo_por_estadia: false,
  tarifa_seleccionada: '',

};
